import React from 'react'
import { connect } from 'react-redux'
import { getBundlePrice } from 'base/lib/bundling'
import { getBundles } from 'base/reducers/cart'

function BundleMessage({ bundles, currentBundle, originalPrice, currencySymbol }) {
  let message
  const bundledPrice = getBundlePrice(currentBundle)

  if (!currentBundle || !bundledPrice) {
    return null
  }

  const totalPrice = originalPrice * currentBundle.threshold_count
  const percentOff = (1 - bundledPrice / totalPrice) * 100
  const formattedPrice = `${currencySymbol}${bundledPrice}`
  const totalTowardsBundle = bundles[currentBundle.id]
    ? bundles[currentBundle.id].reduce((total, lineItem) => total + lineItem.quantity, 0)
    : 0

  if (totalTowardsBundle === 0) {
    message = `${currentBundle.threshold_count} for ${formattedPrice}—save ${Math.round(
      percentOff,
    )}%`
  } else if (totalTowardsBundle < currentBundle.threshold_count) {
    message = `Add ${
      currentBundle.threshold_count - totalTowardsBundle
    } more to your bundle—save ${currencySymbol}${totalPrice - bundledPrice}`
  } else {
    message = `Add more for ${currencySymbol}${currentBundle.converted_discounted_price_per_unit}`
  }

  return <p className="bundle__messasge">{message}</p>
}

function mapStateToProps(state) {
  return {
    bundles: getBundles(state.cart),
  }
}

export default connect(mapStateToProps)(BundleMessage)
